"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _react = _interopRequireDefault(require("react"));
var _escapeRegExp = _interopRequireDefault(require("lodash/escapeRegExp"));
const Item = _ref => {
  let {
    label,
    inputValue
  } = _ref;
  // Capture the text, if any, that matches the inputValue
  inputValue = (0, _escapeRegExp.default)(inputValue);
  const matchStart = label.toLowerCase().search(inputValue.toLowerCase());
  const matchEnd = matchStart + inputValue.length;
  const beforeMatchingText = (0, _slice.default)(label).call(label, 0, matchStart);
  const matchingText = (0, _slice.default)(label).call(label, matchStart, matchEnd);
  const afterMatchingText = (0, _slice.default)(label).call(label, matchEnd);

  // Highlight a portion of the text if it matches the inputValue
  if (matchStart >= 0) {
    return /*#__PURE__*/_react.default.createElement("span", null, beforeMatchingText, /*#__PURE__*/_react.default.createElement("strong", null, matchingText), afterMatchingText);
  } else {
    return /*#__PURE__*/_react.default.createElement("span", null, label);
  }
};
var _default = exports.default = Item;
Item.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Item"
};